import GanttView from '@Task/views/Gantt.vue';
import ScheduleView from '@Task/views/Scheduler.vue';
import KanbanView from '@Task/views/Kanban.vue';
import ListView from '@Task/views/List.vue';
// import TasksView from '@Task/views/Tasks.vue';
import MainTaskPage from '@Task/views/index.vue';
import permissions from '../Share/config/permissions';
import { $has } from '@/utils';
import TaskboardCharts from './views/TaskboardCharts.vue';
import store from '@Store';

export default [
  {
    path: '/:id/:taskTypeId',
    component: MainTaskPage,
    meta: {
      requiresAuth: true,
      facilityScope: true,
      layout: 'viewer-layout',
    },
    children: [
      // {
      //   path: '',
      //   name: 'tasks',
      //   component: TasksView,
      //   meta: {
      //     requiresAuth: true,
      //     title: 'Tasks',
      //     layout: 'viewer-layout',
      //   },
      // },
      {
        path: 'gantt',
        name: 'gantt',
        component: GanttView,
        meta: {
          requiresAuth: true,
          title: 'Gantt Chart',
          layout: 'viewer-layout',
          permissions: [permissions.Gantt.View],
        },
      },
      {
        path: 'list',
        name: 'list',
        component: ListView,
        meta: {
          requiresAuth: true,
          title: 'List',
          layout: 'viewer-layout',
          permissions: [permissions.TaskTracker.View],
        },
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: ScheduleView,
        meta: {
          requiresAuth: true,
          title: 'Schedule Chart',
          layout: 'viewer-layout',
          permissions: [permissions.Scheduler.View],
        },
      },
        {
        path: 'task-board-charts',
        name: 'task-board-charts',
        component: TaskboardCharts,
        meta: {
          requiresAuth: true,
          title: 'Task Charts',
          layout: 'viewer-layout',
          permissions: [permissions.TaskTracker.View],
        },
      },
      {
        path: '',
        name: 'kanban',
        component: KanbanView,
        meta: {
          requiresAuth: true,
          title: 'Kanban',
          layout: 'viewer-layout',
          // Don't set permissions here to prevent global guard from blocking access
          // We'll check permissions in the beforeEnter guard instead
        },
        beforeEnter: (to, from, next) => {
          // Skip permission-based redirect during programmatic navigation (GO_BACK/GO_FORWARD)
          // This prevents the guard from creating unwanted navigation that records to history
          // Issue #8 fix: Route guards were not aware of the navigation history system
          const activeNavId = store.state.NAVIGATION_HISTORY?.activeNavigationId;
          if (activeNavId) {
            // Programmatic navigation in progress - proceed without permission redirect
            // The user is navigating back to a route they previously had access to
            next();
            return;
          }

          // Normal permission-based redirect logic (only for user-initiated navigation)
          // If user has permission for Kanban, proceed
          if ($has(permissions.TaskTracker.View)) {
            next();
          }
          // If user has permission for Gantt, redirect there
          else if ($has(permissions.Gantt.View)) {
            next({ name: 'gantt', params: to.params });
          }
          // If user has permission for Schedule, redirect there
          else if ($has(permissions.Scheduler.View)) {
            next({ name: 'schedule', params: to.params });
          }
          // If no permissions for any view, redirect to facility page
          else {
            next({ name: 'error-not-authorize', query: { redirected: to.path } });
          }
        },
      },
    ],
  },
];
